import { useState } from 'react';
import { Loader2 } from 'lucide-react';
import { EmailCampaign, useEmailCampaigns } from '../../queries/emailCampaigns';
import { EmailCampaignDetailDialog } from './EmailCampaignDetailDialog';
import { GenerateTipsEmailPanel } from './GenerateTipsEmailPanel';
import { ScheduledEmailNotesPanel } from './ScheduledEmailNotesPanel';

export function EmailCampaignsPage() {
  const { data: campaigns = [], isLoading } = useEmailCampaigns();
  const [viewing, setViewing] = useState<EmailCampaign | null>(null);

  return (
    <div className="space-y-4">
      <ScheduledEmailNotesPanel />
      <GenerateTipsEmailPanel />
      <p className="text-sm text-muted-foreground">n8n-generated daily tips drafts, awaiting review and send.</p>

      {isLoading ? (
        <div className="flex justify-center py-12">
          <Loader2 className="h-6 w-6 animate-spin text-muted-foreground" />
        </div>
      ) : (
        <div className="overflow-x-auto rounded-lg border border-border">
          <table className="w-full text-sm">
            <thead className="bg-muted text-left text-xs font-medium uppercase tracking-wide text-muted-foreground">
              <tr>
                <th className="px-3 py-2">Campaign ID</th>
                <th className="px-3 py-2">Type</th>
                <th className="px-3 py-2">Tips date</th>
                <th className="px-3 py-2">Status</th>
                <th className="px-3 py-2"></th>
              </tr>
            </thead>
            <tbody className="divide-y divide-border">
              {campaigns.map((campaign) => (
                <tr key={campaign.id}>
                  <td className="px-3 py-2 font-medium">{campaign.campaign_id}</td>
                  <td className="px-3 py-2 text-muted-foreground">{campaign.email_type}</td>
                  <td className="px-3 py-2 text-muted-foreground">{campaign.tips_date}</td>
                  <td className="px-3 py-2">
                    <span className="rounded-full bg-muted px-2 py-0.5 text-xs text-muted-foreground">{campaign.status}</span>
                  </td>
                  <td className="px-3 py-2 text-right">
                    <button onClick={() => setViewing(campaign)} className="text-sm font-medium text-primary hover:underline">
                      {campaign.status === 'sent' ? 'View' : 'Review & Send'}
                    </button>
                  </td>
                </tr>
              ))}
              {campaigns.length === 0 && (
                <tr>
                  <td colSpan={5} className="px-3 py-8 text-center text-muted-foreground">
                    No email campaigns yet.
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      )}

      {viewing && <EmailCampaignDetailDialog campaign={viewing} onClose={() => setViewing(null)} />}
    </div>
  );
}
